import { getRouteQuery } from './Route';
import * as queryString from './QueryString';
import requestLib from './Request';
import { isCustomPage } from './Amalgam';
import { putSessionStorage, getSessionStorage } from './LocalStorage';

let groupCatalogueAmalgamObject = null;
let getGroupCatalogueAmalgamPromise = null;
let groupRouteSlugs;
let productSectionHomePage = null;

export const setProductSectionHomePage = (value) => {
  productSectionHomePage = value;
};
export const getProductSectionHomePage = () => productSectionHomePage;

export const SESSION_STORAGE_KEYS = {
  SHOWCASE_ID: 'SHOWCASE_ID'
};
export const setGroupRouteSlugs = ({ routeSlugs }) => {
  groupRouteSlugs = routeSlugs;
};

export const getGroupRouteSlugs = () => groupRouteSlugs || {};

export const getCommonAmalgamForGroupCatalogue = () => groupCatalogueAmalgamObject || {};

export const setCommonAmalgamForGroupCatalogue = (amalgamObject) => {
  if (!groupCatalogueAmalgamObject) {
    groupCatalogueAmalgamObject = {};
  }

  groupCatalogueAmalgamObject.moreCataloguesAvailable = amalgamObject.moreCataloguesAvailable;
  groupCatalogueAmalgamObject.removeGroupCatalogueTitle = amalgamObject.removeGroupCatalogueTitle;
  groupCatalogueAmalgamObject.catalogues = amalgamObject.catalogues;
  groupCatalogueAmalgamObject.allCatalogueIds = amalgamObject.allCatalogueIds;
  groupCatalogueAmalgamObject.showcaseId = amalgamObject.showcaseId;
  groupCatalogueAmalgamObject.cataloguesPosition = amalgamObject.cataloguesPosition;
  groupCatalogueAmalgamObject.sortOrder = amalgamObject.sortOrder;
  groupCatalogueAmalgamObject.companyHomeLayout =
    amalgamObject.companyExperiments.companyHomeLayout;
  groupCatalogueAmalgamObject.groupCatalogueCustomAspectRatio =
    amalgamObject.companyExperiments.groupCatalogueCustomAspectRatio;
  groupCatalogueAmalgamObject.hashedDomainTag = amalgamObject.hashedDomainTag;
  groupCatalogueAmalgamObject.referrer = amalgamObject.referrer;
  groupCatalogueAmalgamObject.referrerVal = amalgamObject.referrerVal;
  groupCatalogueAmalgamObject.groupBackgroundContain = amalgamObject.groupBackgroundContain;
  groupCatalogueAmalgamObject.loadCloudfront = amalgamObject.loadCloudfront;
  groupCatalogueAmalgamObject.removeGroupCatalogueGradient =
    amalgamObject.removeGroupCatalogueGradient;
  groupCatalogueAmalgamObject.removeGroupCatalogueTitle = amalgamObject.removeGroupCatalogueTitle;
  groupCatalogueAmalgamObject.openId = amalgamObject.openId;
  groupCatalogueAmalgamObject.viewingNowId = amalgamObject.viewingNowId;
  groupCatalogueAmalgamObject.disableAnalytics = amalgamObject.disableAnalytics;
  groupCatalogueAmalgamObject.companyAddress = amalgamObject.companyAddress;
  groupCatalogueAmalgamObject.formattedAddress = amalgamObject.formattedAddress;
  groupCatalogueAmalgamObject.slug = amalgamObject.slug;
  groupCatalogueAmalgamObject.removeGroupCompanyCard = amalgamObject.removeGroupCompanyCard;
  groupCatalogueAmalgamObject.removeCompanyContactDetailsFromCatalogue =
    amalgamObject.removeCompanyContactDetailsFromCatalogue;
  groupCatalogueAmalgamObject.isCustomPage = amalgamObject.isCustomPage;
};

export const setShowcaseIdSessionStorage = (showcaseId) => {
  putSessionStorage(SESSION_STORAGE_KEYS.SHOWCASE_ID, showcaseId);
};

export const getShowCaseIdFromSessionStorage = () =>
  getSessionStorage(SESSION_STORAGE_KEYS.SHOWCASE_ID);

export const setShowcaseId = (showcaseId) => {
  if (!groupCatalogueAmalgamObject) {
    groupCatalogueAmalgamObject = {};
  }
  groupCatalogueAmalgamObject.showcaseId = showcaseId;
};

export const getShowcaseId = () => (groupCatalogueAmalgamObject || {}).showcaseId;

export const getCatalogues = () => (groupCatalogueAmalgamObject || {}).catalogues || [];
export const getAllCatalogueIds = () => (groupCatalogueAmalgamObject || {}).allCatalogueIds || [];
export const areMoreCataloguesAvailable = () =>
  (groupCatalogueAmalgamObject || {}).moreCataloguesAvailable;
export const getCataloguesPosition = () =>
  (groupCatalogueAmalgamObject || {}).cataloguesPosition || {};
export const getSortOrder = () => (groupCatalogueAmalgamObject || {}).sortOrder;
export const getGroupCatalogueCustomAspectRatio = () =>
  (groupCatalogueAmalgamObject || {}).groupCatalogueCustomAspectRatio;

/* Show grid layout only when companyExperiment has grid view enabled and number of catalogue's are more than 3 */
export const showCataloguesInGridView = () =>
  ((groupCatalogueAmalgamObject || {}).companyHomeLayout === 'grid' &&
    getAllCatalogueIds() &&
    getAllCatalogueIds().length > 3) ||
  isCustomPage();
export const getHashedDomainTag = () => (groupCatalogueAmalgamObject || {}).hashedDomainTag;

export const getReferrer = () => (groupCatalogueAmalgamObject || {}).referrer;
export const getReferrerVal = () => (groupCatalogueAmalgamObject || {}).referrerVal;
export const groupBackgroundContain = () =>
  (groupCatalogueAmalgamObject || {}).groupBackgroundContain;
export const shouldLoadCloudfront = () => (groupCatalogueAmalgamObject || {}).loadCloudfront;
export const shouldRemoveGradient = () =>
  (groupCatalogueAmalgamObject || {}).removeGroupCatalogueGradient || isCustomPage();

export const shouldRemoveCatalogueTitle = () =>
  (groupCatalogueAmalgamObject || {}).removeGroupCatalogueTitle;
export const getOpenId = () => (groupCatalogueAmalgamObject || {}).openId || {};
export const getViewingNowId = () => (groupCatalogueAmalgamObject || {}).viewingNowId;
export const disableAnalytics = () => (groupCatalogueAmalgamObject || {}).disableAnalytics || false;
export const getCompanyAddress = () => (groupCatalogueAmalgamObject || {}).companyAddress;
export const getFormattedAddress = () => (groupCatalogueAmalgamObject || {}).formattedAddress;
export const getSlug = () => (groupCatalogueAmalgamObject || {}).slug;
export const shouldRemoveGroupCompanyCard = () =>
  (groupCatalogueAmalgamObject || {}).removeGroupCompanyCard;
export const shouldRemoveCompanyContactDetails = () =>
  (groupCatalogueAmalgamObject || {}).removeCompanyContactDetailsFromCatalogue;

export const isGroupCatalogueAmalgamFetched = () => {
  if (!groupCatalogueAmalgamObject) {
    return false;
  }

  if (
    (groupCatalogueAmalgamObject || {}).catalogues &&
    (groupCatalogueAmalgamObject || {}).allCatalogueIds
  ) {
    return true;
  }
  return false;
};

// NOTE: Currently unused, may be required if missing group catalogue amalgam data must be fetched
export const getGroupCatalogueAmalagamData = ({ companySlug, randomSlug, tabIndex = {} }) => {
  const { referrer, referrerVal } = getRouteQuery();

  if (isGroupCatalogueAmalgamFetched()) {
    return Promise.resolve(groupCatalogueAmalgamObject);
  }

  if (getGroupCatalogueAmalgamPromise) {
    return getGroupCatalogueAmalgamPromise;
  }

  getGroupCatalogueAmalgamPromise = new Promise((resolve, reject) => {
    const query = queryString.stringify({
      companySlug,
      randomSlug,
      referrer,
      referrerVal,
      tabIndex
    });

    requestLib({
      method: 'GET',
      url: `/api/amalgam/group-catalogue?${query}`
    })
      .then((response) => {
        setCommonAmalgamForGroupCatalogue(response.amalgam);
        resolve();
        getGroupCatalogueAmalgamPromise = null;
      })
      .catch(() => {
        reject();
        getGroupCatalogueAmalgamPromise = null;
      });
  });

  return getGroupCatalogueAmalgamPromise;
};
